import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.FirstTimeSetupPages.ProfileStepContainer', {
    wrongEmailSso: 'The email address does not match the invitation. Please try again',
});
